module.exports = __webpack_public_path__ + "img/test.8ab1563b.png";